import type { QuickDestination } from '../types'
import type { Language } from '../types'
import type { Translator } from '../i18n/i18n'

interface QuickDestinationsProps {
  destinations: QuickDestination[]
  language: Language
  t: Translator
  onPick: (destination: QuickDestination) => void
}

const iconByCategory: Record<string, string> = {
  beach: '🌊',
  culture: '🎬',
  university: '🎓',
  port: '⚓',
  restaurant: '🥩',
}

export function QuickDestinations({ destinations, language, t, onPick }: QuickDestinationsProps) {
  return (
    <section className="quick-section" aria-labelledby="quick-heading">
      <div className="section-heading">
        <div>
          <span className="step">Q</span>
          <h2 id="quick-heading">{t('quickTitle')}</h2>
        </div>
        <span>{t('quickSubtitle')}</span>
      </div>
      <div className="quick-grid">
        {destinations.map((destination) => (
          <button className="quick-card" type="button" key={destination.id} onClick={() => onPick(destination)}>
            <span className="quick-icon" aria-hidden="true">{iconByCategory[destination.category] ?? '📍'}</span>
            <span>
              <strong>{destination.names[language]}</strong>
              {destination.names[language] !== destination.nameEn && <small><bdi>{destination.nameEn}</bdi></small>}
            </span>
            <span className="verify-dot" title={t('verificationNeeded')}>!</span>
          </button>
        ))}
      </div>
      <p className="hint">{t('quickHint')}</p>
    </section>
  )
}
